import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import apiClient from '../utils/apiClient';
import config from '../utils/config';

interface SignupState {
    firstName: string | null;
    lastName: string | null;
    labName: string | null;
    mobileNumber: string | null;
    officialEmail: string | null;
    address: string | null;    
    password: string | null;
    loading: boolean;
    error: string | null;
    response: string | null;
}

const initialState: SignupState = {
    loading: false,
    error: null,
    response: null,
    firstName: '',
    lastName: '',
    labName: '',
    mobileNumber: '',
    officialEmail: '',
    address: '',
    password: '',
}

// Async thunk for signup
export const signupMember = createAsyncThunk(
    'signup/signupMember',
    async (memberData: SignupState, thunkAPI) => {
        try {
            const response = await apiClient.post(`${config.services.ums}/api/v1/lab-users`, {
                first_name: memberData.firstName,
                last_name: memberData.lastName,
                lab_name: memberData.labName,
                lab_branch_email: memberData.officialEmail,
                lab_mobile_number: memberData.mobileNumber,
                address: memberData.address,
                password: memberData.password,
                role: 'labUser'
            });
            return response.data;
        } catch (error: AxiosError | any) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

const signupSlice = createSlice({
    name: 'signup',
    initialState,
    reducers: {
        resetSignupState: (state) => {
            state.firstName = null;
            state.lastName = null;
            state.labName = null;
            state.mobileNumber = null;
            state.officialEmail = null;
            state.password = null;
            state.address = null;
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(signupMember.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(signupMember.fulfilled, (state, action) => {
                console.log(action.payload);
                state.loading = false;
                state.response = action.payload.data || action.payload;
            })
            .addCase(signupMember.rejected, (state, action) => {
                console.log(action.payload);
                state.loading = false;
            });
    },
});

export const { resetSignupState } = signupSlice.actions;

export default signupSlice.reducer;